import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13877386&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=13877386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13877386",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13877386')) {
      api.createRecord('13877386', component.options)
    } else {
      api.reload('13877386', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13877386&scoped=true&", function () {
      api.rerender('13877386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/index.vue"
export default component.exports